import "./index.css";

import React from 'react';
import DialogComponent, {DIALOG_TYPE, executeComponentCallback} from 'Core/components/DialogComponent';
import * as pageConfig from '../../config';
import PropTypes from 'prop-types';
import {QUESTIONNAIRE_VERSIONS} from 'Const/questionnaire';
import Label from 'Core/components/display/Label';
import Icon from 'Core/components/display/Icon';

class QuestionnaireCreateVersionDialog extends DialogComponent {
	constructor(props) {
		super(props, {
			dialogType: DIALOG_TYPE.MESSAGE,
			translationPath: `${pageConfig.translationPath}.QuestionnairePopup.QuestionnaireCreateVersion`,
			domPrefix: 'questionnaire-create-version-dialog',
		});
	}
	
	render() {
		const {dialogGUIID} = this.props;
		
		return this.renderDialog(
			this.renderTitle(`${this.t('title')}:`),
			(
				<div className={`${this.getOption('domPrefix')}`}>
					<div className="card-grid per-row-2">
						{QUESTIONNAIRE_VERSIONS.map(v =>
							<div
								key={v}
								className="card action-card"
								onClick={() => executeComponentCallback(this.props.onSelect, dialogGUIID, v)}
							>
								<div className="card-content">
									<Icon symbol={(v === '1' ? 'history' : 'certificate')} />
									<Label element="p" content={this.t(v, 'constants.questionnaireVersion')} />
								</div>
							</div>
						)}
					</div>
				</div>
			),
		);
	}
}

/**
 * Define component's own props that can be passed to it by parent components
 */
DialogComponent.propTypes = {
	// Unique GUI ID of the dialog
	// @note This is automatically sent by the global Dialog component.
	dialogGUIID: PropTypes.string,
	// Dialog options
	// @note This is automatically sent by the global Dialog component.
	dialogOptions: PropTypes.object,
	// Action used to close the dialog
	// @note This is automatically sent by the global Dialog component.
	dialogCloseAction: PropTypes.func,

	// Events
	onSelect: PropTypes.func, // Params: {string} dialogGUIID, {QuestionnaireVersion} version
	onClose: PropTypes.func,
};

export default QuestionnaireCreateVersionDialog;